export const usePlatform = () => {
  // Default to empty string if navigator is undefined (for SSR compatibility)
  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '';

  const isAndroid = /android/i.test(userAgent);

  const isIOSUserAgent = /iphone|ipad|ipod/i.test(userAgent);

  // Determine if we can access navigator and document
  const canCheckPlatform =
    typeof navigator !== 'undefined' && navigator.platform;
  const canCheckTouch = typeof document !== 'undefined';

  // Check navigator.platform for iOS devices
  const isIOSPlatform =
    canCheckPlatform &&
    [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod',
    ].includes(navigator.platform);

  // Check for iPad on iOS 13+ which presents as Mac with touch capability
  const isIOSOnMac =
    canCheckPlatform &&
    canCheckTouch &&
    userAgent.includes('Mac') &&
    'ontouchend' in document;

  // Combine all iOS detection methods
  const isIOS = isIOSUserAgent || Boolean(isIOSPlatform) || Boolean(isIOSOnMac);

  const isIOSChrome = isIOS && /CriOS/.test(userAgent);

  return { isAndroid, isIOS, isIOSChrome };
};
